import { Globe2, LayoutDashboard } from 'lucide-react';

/** Admin template navigation — Bookly-style grouped sidebar. */
const sidebarConfig = () => [
  {
    label: 'Main',
    items: [
      {
        title: 'Overview',
        path: '/dashboard',
        icon: LayoutDashboard,
        exact: true,
      },
      {
        title: 'Sites',
        path: '/sites',
        icon: Globe2,
      },
    ],
  },
];

export default sidebarConfig;
